import { TEAM_COLUMN_NAME } from '../../productionBoard.constants';

const defaultProps = () => ({ style: { textAlign: 'right', minWidth: 60 } });

export const PRODUCTION_BY_WEEK_COLUMNS = [
  {
    name: 'empNo',
    options: {
      display: 'excluded'
    }
  },
  {
    name: TEAM_COLUMN_NAME,
    label: 'Team',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'weekOfMonth-1',
    label: '1',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-2',
    label: '2',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-3',
    label: '3',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-4',
    label: '4',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-5',
    label: '5',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-6',
    label: '6',
    options: {
      display: false,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      display: true,
      sort: true,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: () => ({
        style: { textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }
      })
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'name',
  direction: 'asc'
};
